import type { Purchase } from '../types/purchase';

// ─── COMPRAS RECIENTES (REALES) ────────────────────────────────
// Cargá acá solo compras reales (o conectá este array a tu plataforma
// de pagos: Hotmart, Mercado Pago, etc.). Usá nombre de pila y ciudad,
// con consentimiento del comprador. Si el array está vacío, el aviso
// de "compra verificada" no se muestra.
//
// Ejemplo de formato:
// { name: 'María', city: 'Rosario', province: 'Santa Fe', purchasedAt: '2026-09-30T18:20:00-03:00' }
export const recentPurchases: Purchase[] = [];
